import ApiService from "@/common/api.service"

export const PreServiceReportService = {
    async getPreServices(params) {
        const res = await ApiService.get(`/pre-services${params}`);
        return res.data
    },
    async getPreServiceSummary(params) {
        const res = await ApiService.get(`/preserviceReport/summary-report${params}`);
        return res.data;
    },
    getGenericEntryReportWP(page, pageSize, params = "") {
        return ApiService.get(
            `/preserviceReport/genericEntryReport?page=${page}&pageSize=${pageSize}${params}`
        );
    },
    getGenericEntryAggReportWP(page, pageSize, params = "") {
        return ApiService.get(
            `/preserviceReport/genericEntryAggReport?page=${page}&pageSize=${pageSize}${params}`
        );
    },
    getPostBasicReportWP(page, pageSize, params = "") {
        return ApiService.get(
            `/preserviceReport/postBasicReport?page=${page}&pageSize=${pageSize}${params}`
        );
    },
    getPostBasicAggReportWP(page, pageSize, params = "") {
        return ApiService.get(
            `/preserviceReport/postBasicAggReport?page=${page}&pageSize=${pageSize}${params}`
        );
    },
    getPostGraudateReportWP(page, pageSize, params = "") {
        return ApiService.get(
            `/preserviceReport/postGraduateReport?page=${page}&pageSize=${pageSize}${params}`
        );
    },
    getPostGraudateAggReportWP(page, pageSize, params = "") {
        return ApiService.get(
            `/preserviceReport/postGraduateAggReport?page=${page}&pageSize=${pageSize}${params}`
        );
    },
}
